import { tracklistSchema } from "@api/tracklists/schemas";
import { oldUserSchema } from "@api/user/schemas";
import { z } from "zod";
import { CommentRating } from "./types";

export const historyCommentSchema = z.object({
	uuid: z.string().uuid(),
	length: z.number(),
	url: z.string().url(),
	created_at: z.coerce.date(),
});

export const historyTrackListSchema = z.lazy(() =>
	tracklistSchema.extend({ user_comments: z.array(historyCommentSchema) }),
);

export const tracklistCommentSchema = z.object({
	uuid: z.string().uuid(),
	author: z.lazy(() => oldUserSchema),
	url: z.string().url(),
	length: z.number(),
	created_at: z.coerce.date(),
	rating: z.object({
		negative: z.number().int(),
		positive: z.number().int(),
		user_choice: z.nativeEnum(CommentRating),
	}),
});
